<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isDepositV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="width:30%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="12">
                                        <h3 id="traffic" class="card-title mb-0 text-center">{{this.getLanguage["MTA"]["CA"]}}</h3>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content dpt-wtd" style="min-height: 180px;">
                                    <CRow>
                                        <CCol col="12">
                                            <p class="font-weight-bold text-center">{{this.strTnxConfirm}}</p>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="!bool_isWithdraw">
                                        <CCol col="4">{{this.getLanguage["MEM"]["PROMO"]}} : </CCol>
                                        <CCol col="8">
                                            <treeselect :multiple="false"
                                                        :key="rtPromoKey"
                                                        :options="dd_promotion"
                                                        :auto-load-root-options="false"
                                                        :placeholder="getLanguage['MEM']['PROMO']"
                                                        class="inline"
                                                        v-model="obj_OutletTran['PI']" />
                                        </CCol>
                                    </CRow>
                                </div>

                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="closeDeposit()">
                                        <span class='xIcon cil-x'></span>
                                        {{this.getLanguage["GL"]["CANCEL"]}}
                                    </CButton>
                                    <CButton color="outline-info" size="sm" @click="processTransaction()">
                                        <span class='checkIcon cil-check'></span>
                                        {{this.getLanguage["GL"]["CONFIRM"]}}
                                    </CButton>
                                </div>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['NO']}}
                                            </template>
                                            <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.edit)">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["ACT"]}}
                                            </template>
                                            <template v-else-if="header == 'AGT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["AGT"]}}
                                                <i @click="setSortTable('AGI')" :class="setSortLogo('AGI')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'U'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['U']}}
                                                <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BR'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MEM"]["BR"]}}
                                            </template>
                                            <template v-else-if="header == 'CBL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['CBL']}}
                                                <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'DA' && bool_DepositFunc">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['DA']}}
                                            </template>
                                            <template v-else-if="header == 'WA' && bool_WithdrawalFunc">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['WA']}}
                                            </template>
                                            <template v-else-if="header == 'DLS' && bool_DLSFunc">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['DLS']}}
                                            </template>
                                            <template v-else-if="header == 'TSID'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                <span style="color: darkorange; font-weight: bold; ">{{getLanguage['MEM']['TSID']}}</span> /
                                                <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span>
                                            </template>
                                            <template v-else-if="header == 'LLTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['LLTS']}} / {{getLanguage['MEM']['LLIP']}}
                                                <i @click="setSortTable('LLTS')" :class="setSortLogo('LLTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'LD'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['LD']}}
                                                <i @click="setSortTable('LD')" :class="setSortLogo('LD')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'LLD'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['LLD']}}
                                            </template>
                                            <template v-else-if="header == 'IM'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['LOGRPT']['DEV']}}
                                                <i @click="setSortTable('IM')" :class="setSortLogo('IM')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'RSN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['RSN']}}
                                            </template>
                                            <template v-else-if="header == 'SAGN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['SAGT']}}
                                                <i @click="setSortTable('SAGN')" :class="setSortLogo('SAGN')" class="sortlogo"></i>
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage['MEM']['MOLN']}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel'>{{this.getLanguage['GL']['AGT']}} :</span>
                                <div class="inline">
                                    <div class="d-flex">
                                        <input type="checkbox" v-model="searchExcludeSubAgent" id="searchExcludeSubAgent" />
                                        <label class="searchLabel ml-1" for="searchExcludeSubAgent">{{getLanguage["GL"]["ODA"]}}</label>
                                    </div>
                                </div>
                                <customtreeselect :multiple="false"
                                                  :load-options="loadAgentOptions"
                                                  :options="ddAgentList"
                                                  :auto-load-root-options="convertToBool(searchAgent)"
                                                  :disable-branch-nodes="true"
                                                  :defaultExpandLevel="Infinity"
                                                  @input="selectAgentOptions"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="searchAgent" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :options="ddSubAgentList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="searchSubAgent"
                                            :disabled="searchExcludeSubAgent"
                                            openDirection="below"
                                            @input="selectSubAgentOptions" />

                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['U']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :cacheOptions="false"
                                            :options="ddMemberList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            v-model="searchUsername" />
                            </div>
                        </div>
                        <div class=' searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class='searchBtn' size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage['BTN']['SR']}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-summarywrapper'>
                <div class="custom-table-wrapper">
                    <table class='custom-table custom-tableMP afb-blue'>
                        <thead>
                            <tr>
                                <th colspan="100%">{{this.getLanguage['MEM']['MOS']}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_OnlineSummary.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-if=" arr_OnlineSummary.length != 0" @click="bool_showSummary = !bool_showSummary" class='kema-eft'>
                            <td style="width:50%">{{this.getLanguage['MTA']['GT']}}</td>
                            <td style="width:50%" class="tableCtnRight">{{ formatNumber(grandTotal, 0) }}</td>
                        </tr>
                        </tbody>
                        <thead v-if="bool_showSummary">
                            <tr>
                                <th style="width:50%">{{this.getLanguage['MTA']['BN']}}</th>
                                <th style="width:50%" class="tableCtnRight">{{this.getLanguage['MEM']['MTO']}}</th>
                            </tr>
                        </thead>
                        <tbody v-if="bool_showSummary">
                        <td colspan="100%" v-if=" arr_OnlineSummary.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_OnlineSummary">
                            <td><a href="#" v-if="arr_OnlineSummary.length > 1" @click="autoFilterAG(data)">{{ data.AGN }}</a><span v-else>{{ data.AGN }}</span></td>
                            <td class="tableCtnRight">{{ formatNumber(data.TO, 0) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage['MEM']['MOL']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.edit)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'AGT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["AGT"]}}
                                        <i @click="setSortTable('AGI')" :class="setSortLogo('AGI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MEM"]["BR"]}}
                                    </template>
                                    <template v-else-if="header == 'CBL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CBL']}}
                                        <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'DA' && bool_DepositFunc">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['DA']}}
                                    </template>
                                    <template v-else-if="header == 'WA' && bool_WithdrawalFunc">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['WA']}}
                                    </template>
                                    <template v-else-if="header == 'DLS' && bool_DLSFunc">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['DLS']}}
                                    </template>
                                    <template v-else-if="header == 'TSID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <span style="color: darkorange; font-weight: bold; ">{{getLanguage['MEM']['TSID']}}</span> /
                                        <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span>
                                    </template>
                                    <template v-else-if="header == 'LLTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['LLTS']}} / {{getLanguage['MEM']['LLIP']}}
                                        <i @click="setSortTable('LLTS')" :class="setSortLogo('LLTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'LD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['LD']}}
                                        <i @click="setSortTable('LD')" :class="setSortLogo('LD')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'LLD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['LLD']}}
                                    </template>
                                    <template v-else-if="header == 'IM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['LOGRPT']['DEV']}}
                                        <i @click="setSortTable('IM')" :class="setSortLogo('IM')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'RSN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['RSN']}}
                                    </template>
                                    <template v-else-if="header == 'SAGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['SAGT']}}
                                        <i @click="setSortTable('SAGN')" :class="setSortLogo('SAGN')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.edit)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'AGT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["AGT"]}}
                                        <i @click="setSortTable('AGI')" :class="setSortLogo('AGI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MEM"]["BR"]}}
                                    </template>
                                    <template v-else-if="header == 'CBL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CBL']}}
                                        <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'DA' && bool_DepositFunc">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['DA']}}
                                    </template>
                                    <template v-else-if="header == 'WA' && bool_WithdrawalFunc">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['WA']}}
                                    </template>
                                    <template v-else-if="header == 'DLS' && bool_DLSFunc">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['DLS']}}
                                    </template>
                                    <template v-else-if="header == 'TSID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <span style="color: darkorange; font-weight: bold; ">{{getLanguage['MEM']['TSID']}}</span> /
                                        <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span>
                                    </template>
                                    <template v-else-if="header == 'LLTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['LLTS']}} / {{getLanguage['MEM']['LLIP']}}
                                        <i @click="setSortTable('LLTS')" :class="setSortLogo('LLTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'LD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['LD']}}
                                        <i @click="setSortTable('LD')" :class="setSortLogo('LD')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'LLD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['LLD']}}
                                    </template>
                                    <template v-else-if="header == 'IM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['LOGRPT']['DEV']}}
                                        <i @click="setSortTable('IM')" :class="setSortLogo('IM')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'RSN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['RSN']}}
                                    </template>
                                    <template v-else-if="header == 'SAGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['SAGT']}}
                                        <i @click="setSortTable('SAGN')" :class="setSortLogo('SAGN')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_MemberList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_MemberList" :class="data.RS == 3? 'freeze-row': ''">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.edit)">
                                    <span v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <span id="actionBtnCol">
                                            <div class="custom_tooltip">
                                                <i class="cil-account-logout" @click='LogoutMember(data)'></i>
                                                <span class="tooltiptext">{{getLanguage["BTN"]["L"]}}</span>
                                            </div>
                                        </span>
                                    </span>
                                    <span v-else-if="isSENS == 1 && data.AGI != curAGI">
                                        <span id="actionBtnCol">
                                            <div class="custom_tooltip">
                                                <i class="cil-account-logout"></i>
                                                <span class="tooltiptext">{{getLanguage["BTN"]["L"]}}</span>
                                            </div>
                                        </span>
                                    </span>
                                </template>
                                <template v-else-if="header == 'AGT'">
                                    <span class="grid-line">{{ data.GN }} ({{ data.GPC }})</span>
                                    <span class="grid-line">{{ data.DMN }}</span>
                                </template>
                                <template v-else-if="header == 'SAGN'">
                                    <span class="saggroupname" v-if="data.SAGGPC != null && data.SAGGPC != ''">{{ data.SAGN }} ({{ data.SAGGPC }})</span>
                                </template>
                                    <template v-else-if="header == 'U'">
                                        <span v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="CheckingMember(data.AGI,data.I)">
                                            <span class="grid-line">
                                                <div class="custom_tooltip">
                                                    <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                                    <span v-if="convertToBool(data.MT)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.MT}}</span>
                                                </div>
                                                <div class="custom_tooltip" v-if="data.TW == 0">
                                                    <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                                    <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                                </div>
                                                <div class="custom_tooltip" v-if="data.HTWT">
                                                    <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                                    <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                                </div>
                                                <div class="custom_tooltip" v-if="data.RP">
                                                    <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                                    <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                                </div>
                                                <div class="float-right ml-1">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                        <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                                    </svg>
                                                </div>
                                            </span>
                                        </span>

                                        <span v-else-if="isSENS == 1 && data.AGI != curAGI">
                                            <span class="grid-line">
                                                <div class="custom_tooltip">
                                                    <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                                    <span v-if="convertToBool(data.MT)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.MT}}</span>
                                                </div>
                                                <div class="custom_tooltip" v-if="data.TW == 0">
                                                    <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                                    <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                                </div>
                                                <div class="custom_tooltip" v-if="data.HTWT">
                                                    <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                                    <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                                </div>
                                                <div class="custom_tooltip" v-if="data.RP">
                                                    <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                                    <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                                </div>
                                                <div class="float-right ml-1">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                        <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                                    </svg>
                                                </div>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'BR'">
                                        <span v-if="data.R != null && data.R != ''">{{ data.R }}</span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'CBL'">
                                        {{ formatNumber(data.CBL, 2, data.CS) }}
                                    </template>
                                    <template v-else-if="header == 'DA' && bool_DepositFunc">
                                        <div class="justify-content-center">
                                            <CInput type="number" placeholder="0" size="sm" v-model="data.depositAmt" class="mwidth150" :prepend="data.CS">
                                                <template #append>
                                                    <CButton size="sm" type="submit" color="primary" style="min-width: auto; z-index: 0; " @click="transactionShortcut(data, 1)">
                                                        <span><i class="fa fa-paper-plane m-0"></i></span>
                                                    </CButton>
                                                </template>
                                            </CInput>
                                        </div>
                                    </template>
                                    <template v-else-if="header == 'WA' && bool_WithdrawalFunc">
                                        <div class="justify-content-center">
                                            <CInput type="number" placeholder="0" size="sm" v-model="data.withdrawAmt" class="mwidth150" :prepend="data.CS">
                                                <template #append>
                                                    <CButton size="sm" type="submit" color="primary" style="min-width: auto; z-index: 0;" @click="transactionShortcut(data, 2)">
                                                        <span><i class="fa fa-paper-plane m-0"></i></span>
                                                    </CButton>
                                                </template>
                                            </CInput>
                                        </div>
                                    </template>
                                    <template v-else-if="header == 'DLS' && bool_DLSFunc">
                                        <div class="justify-content-center">
                                            <CButton size="sm" type="submit" :class="data.HADLS ? 'btn-danger' : 'btn-success'" @click="manualTriggerDLS(data)" :disabled="data.HADLS">
                                                <span>
                                                    <span>{{ getLanguage["AFF"]["ACT"] }}<i class="fa fa-power-off m-0 ml-2" aria-hidden="true"></i></span>
                                                </span>
                                                <div class="spinner-border spinner-border-sm" v-if="data.bool_sendLoading"></div>
                                            </CButton>
                                        </div>
                                    </template>
                                    <template v-else-if="header == 'TSID'">
                                        <span style="text-align:center;display:block">
                                            <span v-if="data.TSI > 0 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="getSystemId(data)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TM }})</span>
                                            </span>
                                            <span v-else-if="data.TSI > 0 && isSENS == 1 && data.AGI != curAGI" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TM }})</span>
                                            </span>
                                            <span class="grid-line" v-else>-</span>
                                            <table class='p-4 mt-2' v-if="opened.includes(data.I)" style="width: 100%; background: #ebedef">
                                                <thead>
                                                    <tr>
                                                        <th>{{ getLanguage['LOGRPT']['SI'] }}</th>
                                                        <th>{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="(row,index) in arry_systemId[data.I]">
                                                        <tr style="text-align: left;">
                                                            <td @click="row.MI>0?toggleFingPrintId(row,data.I):{}" :class="{opened: opened.includes(row.UBI+'_'+row.SI)}" :style="[row.MI>0?{'cursor':'pointer'}:{}]">{{ row.SI }} <span style="color:red" v-if="row.MI>0">({{row.MI}})</span></td>
                                                            <td>{{ formatDateTime(row.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                        </tr>
                                                        <tr v-if="opened.includes(row.UBI+'_'+row.SI)" style="background: darkred">
                                                            <td colspan="2" style="padding:2px">
                                                                <table class='p-4' style="width: 100%; background: #ebedef;margin-top:1px">
                                                                    <thead>
                                                                        <tr>
                                                                            <th style="background: darkgoldenrod;padding:0.25rem">{{getLanguage['GL']['NO']}}</th>
                                                                            <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['ACC'] }}</th>
                                                                            <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(item,index) in arry_visitorMembers[row.UBI+'_'+row.SI]" style="text-align:left">
                                                                            <td style="text-align:center">{{ CountItem(index+1) }}</td>
                                                                            <td>
                                                                                <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: item.AGI, i: item.MI, u: item.UB, cf: 7}} : ''" :target="MCMI_V ? '_blank' : null">{{ item.UB }}</router-link>
                                                                            </td>
                                                                            <td style="text-align: right;">{{ formatDateTime(item.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'LLTS'">
                                        <span class="grid-line">{{ formatDateTime(data.LLTS,"YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}</span>
                                        <span class="grid-line"><span class="grid-line"><a target="_blank" :href="checkIpAddress(data.LLIP)">{{data.LLIP}}</a></span></span>
                                    </template>
                                    <template v-else-if="header == 'LD'">
                                        <span class="grid-line">{{ getLoginDuration(data.LLTS, data.CD) }}</span>
                                    </template>
                                    <template v-else-if="header == 'LLD'">
                                        <div class="grid-line position-absolute custom_tooltip">
                                            <span type="button" data-toggle="tooltip" data-placement="left" :title="renderLoginDetails(data, 1)">
                                                <span>{{ renderLoginDetails(data, 0) }}</span>
                                            </span>
                                        </div>
                                    </template>
                                    <template v-else-if="header == 'IM'">
                                        {{ getDevice(data.IM) }}
                                    </template>
                                    <template v-else-if="header == 'RSN'">
                                        <span v-if="data.RSN != ''">{{data.RSN}}</span>
                                        <span v-else>{{getLanguage["MEM"]["DIR"]}}</span>
                                    </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    import draggable from 'vuedraggable';
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'getUserMemberSC']),
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_fingerPrintLoading: [],
                bool_Advanced: false,
                bool_showSearchBar: true,
                str_tableSortBy: "I", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                // dropdown value
                ddAgentList: null,
                ddSubAgentList: null,
                ddDefaultSubBrand: null,
                dd_promotion: [],
                rtPromoKey: 0,
                obj_ManualPromo: {
                    "AGI": 0,
                    "CNT": "",
                    "CNM": "",
                    "R": [],
                },
                rtSubBrand: 0,
                // search fields
                bool_isDepositV: false,
                obj_OutletTran: [],
                bool_DepositFunc: false,
                bool_WithdrawalFunc: false,
                bool_DLSFunc: false,
                constAccessType: constAccessType,
                MCMI_V: false,  
                searchAgent: null,
                searchSubAgent: null,
                searchCurrency: null,
                searchUsername: null,
                arr_MemberList: [],
                opened: [],
                arry_visitorMembers: [],
                arry_systemId: [],
                ddMemberList: [],
                arr_OnlineSummary: [],
                bool_showSummary: true,
                grandTotal: 0,
                defaultReportHeaders: ['NO', 'ACT', 'AGT', 'SAGN','U', 'BR', 'CBL', 'DA', 'WA', 'DLS', 'TSID', 'LLTS', 'LD', 'LLD', 'IM', 'RSN'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
                searchExcludeSubAgent: false
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),

            CheckingMember(agi, mi, from) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi, fr: from } });
                window.open(routeData.href, '_blank');
            },
            getDevice(data) {
                switch (data) {
                    case 1: return this.getLanguage['DEV']['M'];
                    case 2: return this.getLanguage['DEV']['A'];
                    case 3: return this.getLanguage['DEV']['IOS'];
                    case 4: return this.getLanguage['DB']['API'];
                    default: return this.getLanguage['DEV']['D'];

                }
            },
            closeDeposit() {
                this.bool_isDepositV = !this.bool_isDepositV;
            },
            renderLoginDetails(data, isToolTipsText) {
                if (typeof data.LB === 'string' && data.LB != "") {
                    data.LB = JSON.parse(data.LB);
                }
                if ((data.IM == 1 || data.IM == 2 || data.IM == 3) && data.LB != null && isToolTipsText == 0) {
                    var details = "";
                    if (data.LB.Browser != "unknown") {
                        details += data.LB.Browser;
                    }
                    if (data.LB.MobileDevice != "unknown") {
                        details += " " + data.LB.MobileDevice;
                    }
                    else if (data.LB.MobileDeviceManufacturer != "unknown") {
                        details += " " + data.LB.MobileDeviceManufacturer;
                    }
                    return details;
                }
                else if (data.IM == 0 && data.LB != null && isToolTipsText == 0) {
                    return data.LB.Browser;
                }
                else if (data.LB != null && isToolTipsText == 1) {
                    return data.LB.UserAgent;
                }
                return "-";
            },
            getLoginDuration(loginDateTime, currentTime) {
                if (loginDateTime != null) {
                    let d = (new Date(currentTime)) - (new Date(loginDateTime));
                    let W = Math.floor(d / 1000 / 60 / 60 / 24 / 7);
                    let DDAY = Math.floor(d / 1000 / 60 / 60 / 24 - W * 7);
                    let DHR = Math.floor(d / 1000 / 60 / 60 - W * 7 * 24 - DDAY * 24);
                    let DMT = Math.floor(d / 1000 / 60 - W * 7 * 24 * 60 - DDAY * 24 * 60 - DHR * 60);
                    let DSC = Math.floor(d / 1000 - W * 7 * 24 * 60 * 60 - DDAY * 24 * 60 * 60 - DHR * 60 * 60 - DMT * 60);
                    let t = {};
                    ['W', 'DDAY', 'DHR', 'DMT', 'DSC'].forEach(q => { if (eval(q) > 0) { t[q] = eval(q); } });

                    var dateKey = Object.keys(t);
                    var temp = ""
                    for (var i = 0; i < dateKey.length; i++) {
                        temp += t[dateKey[i]] + " ";
                        temp += this.getLanguage['MEM'][dateKey[i]] + " ";
                    }
                }
                else {
                    var temp = ""
                }
                return temp;
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.MTBC) {
                        bgColor = data.MTBC;
                    }

                    if (data.MTC) {
                        textColor = data.MTC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor, padding: '0px 5px', borderRadius: '5px'
                };
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getMemberList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getMemberList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getMemberList(1);
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            selectAgentOptions(value, instanceId) {
                this.searchSubAgent = null;
                if (value) {
                    this.setSearchCriteriaAGI(value);
                }
                else {
                    this.setSearchCriteriaAGI(null);
                }
            },
            selectSubAgentOptions(value, instanceId) {
                if (value) {
                    this.setSearchCriteriaAGI('4-' + value);
                }
                else {
                    this.setSearchCriteriaAGI(null);
                }
            },
            checkIpAddress(ip) {
                if (ip) {
                    return `https://whatismyipaddress.com/ip/${ip}`;
                    //return `https://whatismyipaddress.com/ip/${ip}`;
                }
                else {
                    return '#';
                }
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    var agi = 0;
                    if (this.searchSubAgent) {
                        agi = this.searchSubAgent;
                    } else if (this.searchAgent) {
                        agi = this.searchAgent.split("-")[1];
                    }
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.searchAgent) {
                    var agentList = this.searchAgent.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubAgentList = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.ddSubAgentList = [];
                            }
                            callback(null, that.ddSubAgentList);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                        that.getMemberList(1);
                    });
            },
            getMemberList(loadSummaryData = 0) {
                this.bool_fullLoading = true;
                var that = this;
                var agentGId = null;

                if (this.searchAgent) {
                    var agentList = this.searchAgent.split("-");
                    agentGId = agentList[agentList.length - 1];
                }

                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                //if (agentGId) {
                //    path += "&f.AGI=" + agentGId;
                //}
                if (this.searchSubAgent) {
                    path += "&f.AGI=" + this.searchSubAgent;
                } else if (agentGId) {
                    path += "&f.AGI=" + agentGId;
                }
                if (this.searchCurrency) {
                    path += "&f.CI=" + this.searchCurrency;
                }

                if (this.searchUsername) {
                    path += "&f.MI=" + this.searchUsername;
                }

                path += "&f.LSD=" + loadSummaryData;

                if (!this.searchSubAgent && this.searchExcludeSubAgent) {
                    path += "&f.SAGI=0";
                }

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                this.getDataApi(`/api/m/olnm?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.int_TP = Math.max(d.Item2.D.TotalPages, 1);
                            that.int_Total = d.Item2.D.TotalItems;
                            that.arr_MemberList = d.Item2.D.Items;
                            if (loadSummaryData == 1) {
                                that.grandTotal = 0;
                                for (let index = 0; index < d.Item1.length; index++) {
                                    that.grandTotal += d.Item1[index].TO;
                                }
                                that.arr_OnlineSummary = d.Item1;
                            }
                            that.resizeTableHead();
                        }
                    });
            },
            LogoutMember(data) {
                this.$fire({
                    title: this.getLanguage["GL"]["LOM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["CONFIRM"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            I: data.I,
                            AGI: data.AGI,
                        };

                        this.postDataApi(`/api/m/logoutmem`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getMemberList(1);
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            toggleFingPrintId(data, member_id) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + member_id;
                path += "&f[FPJI]=" + data.SI;
                path += "&f[AGI]=" + data.AGI;

                const index = that.opened.indexOf(data.UBI + '_' + data.SI);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsiu/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_visitorMembers[data.UBI + '_' + data.SI] = d.D.Items;
                                that.opened.push(data.UBI + '_' + data.SI)
                            }
                        });
                }
            },
            getSystemId(data) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.I;

                const index = that.opened.indexOf(data.I);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsi/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_systemId[data.I] = d.D.Items;
                                that.opened.push(data.I)
                            }
                        });
                }
                this.resizeTableHead()
            },
            renderActionType(int_status) {
                switch (int_status) {
                    case 2:
                        return this.getLanguage['MEM']['LGN'];
                        break;
                    default:
                        return this.getLanguage['MEM']['RGT'];
                        break;
                }
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        if (!headerCells[index]) return;  // Add a safety check to avoid undefined errors

                        const headerWidth = headerCells[index].getBoundingClientRect().width;
                        const bodyWidth = cell.getBoundingClientRect().width;
                        const width = `${Math.max(bodyWidth, headerWidth)}px`;

                        headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            transactionShortcut(memData, tranType) {
                // tranType: 1 = deposit, 2 = withdraw
                var actionLang;
                var tranAmt;
                this.obj_OutletTran = [];

                if (memData.I > 0 && ((memData.depositAmt > 0 && tranType == '1') || (memData.withdrawAmt > 0 && tranType == '2'))) {
                    this.getPromotionDDList(memData.AGI, memData.I, memData.CI, memData.depositAmt);

                    //Populate data
                    this.obj_OutletTran['AGI'] = memData.AGI;
                    this.obj_OutletTran['MI'] = memData.I;

                    if (tranType == '1') {  //deposit
                        actionLang = this.getLanguage["TD"]["TT1"];
                        tranAmt = this.formatNumber(memData.depositAmt, 2, memData.CS);
                        this.obj_OutletTran['TA'] = memData.depositAmt;
                        this.bool_isWithdraw = false;
                    }
                    else if (tranType == '2') {  //withdraw
                        actionLang = this.getLanguage["TD"]["TT2"];
                        tranAmt = this.formatNumber(memData.withdrawAmt, 2, memData.CS);
                        this.obj_OutletTran['TA'] = memData.withdrawAmt;
                        this.bool_isWithdraw = true;
                    }

                    this.strTnxConfirm = memData.U + " " + actionLang + " " + tranAmt;
                    this.bool_isDepositV = !this.bool_isDepositV;
                }
            },
            getPromotionDDList(agi, memberId, currencyId, depositAmt) {
                var that = this;

                this.getDataApi(`/api/dd/gapromo/${agi}/${memberId}/${currencyId}/${depositAmt}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_promotion = d.dropdownlist;
                            that.rtPromoKey = that.rtPromoKey == 0 ? 1 : 0;
                        }
                        else {
                            that.dd_promotion = [];
                        }
                    });
            },
            processTransaction() {
                // tranType: 1 = deposit, 2 = withdraw
                var that = this;

                if (this.obj_OutletTran['MI'] > 0) {
                    //common value for manual deposit/withdraw transaction
                    this.obj_OutletTran['AC'] = 2;
                    this.obj_OutletTran['CCP'] = 0;
                    this.obj_OutletTran['IMA'] = 1;
                    this.obj_OutletTran['PM'] = 3;
                    this.obj_OutletTran['RS'] = 2;
                    this.obj_OutletTran['TM'] = 1;

                    if (!this.bool_isWithdraw) {  //deposit
                        this.obj_OutletTran['DSRM'] = "::[MTA][DSM]::";
                        this.obj_OutletTran['DSRT'] = "::[MTA][DST]::";
                        this.obj_OutletTran['TT'] = "1";
                    }
                    else if (this.bool_isWithdraw) {  //withdraw
                        this.obj_OutletTran['WSRT'] = "::[MTA][WST]::";
                        this.obj_OutletTran['WSRM'] = "::[MTA][WSM]::";
                        this.obj_OutletTran['IITO'] = 1;
                        this.obj_OutletTran['TT'] = "2";
                    } else return;

                    that.bool_fullLoading = true;

                    this.postDataApiWithAttach(`/api/memtrans/ap`, this.obj_OutletTran,
                        function (d, s) {
                            if (s) {

                                if (that.obj_OutletTran['PI'] > 0) {
                                    that.processManualPromo();
                                } else {
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    that.getMemberList(1);
                                }
                                that.bool_isDepositV = !that.bool_isDepositV;
                            }
                            that.bool_fullLoading = false;
                        });
                }
            },
            processManualPromo() {
                var that = this;

                if (this.obj_OutletTran['PI'] > 0) {

                    this.obj_ManualPromo.R.push({
                        "MI": this.obj_OutletTran['MI'],
                        "PI": this.obj_OutletTran['PI']
                    })

                    this.obj_ManualPromo['AGI'] = this.obj_OutletTran['AGI'];
                    this.obj_ManualPromo['CNT'] = "::[PM][PST]::";
                    this.obj_ManualPromo['CNM'] = "::[PM][PSM]::";
                }

                this.postDataApi(`/api/mpromo/mapv2`, this.obj_ManualPromo,
                    function (d, s) {
                        if (s) {
                            if (d != null && d.D != null && d.D.Items != null && d.D.Items.length > 0 && !d.D.Items[0].S) {
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("DEPOSIT.DSRT") + " " + that.processMessage(d.D.Items[0].R));
                            }
                            else {
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            }
                        }
                        else {
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("DEPOSIT.DSRT") + " " + that.utilGetErrorLanguage("PM.PRT"));
                        }
                        that.bool_fullLoading = false;
                        that.getMemberList(1);
                    });
            },
            processMessage(_errArr) {
                let temp = '';
                let msg = '';

                for (var i = 0; i < _errArr.length; i++) {
                    if (_errArr[i].ERRC && _errArr[i].CL && _errArr[i].CL.length > 0) {
                        var arr_args = this.splitColumnName(_errArr[i].CL);
                        var targs = [];
                        targs.push(this.utilGetErrorLanguage(_errArr[i].ERRC));
                        for (var j = 0; j < arr_args.length; j++) {
                            targs.push(arr_args[j]);
                        }

                        temp = String.format.apply(null, targs);
                    }
                    else if (_errArr[i].ERRC) {
                        temp = this.utilGetErrorLanguage(_errArr[i].ERRC);
                    }
                    else if (_errArr[i].CL && _errArr[i].CL.length > 0) {
                        if (_errArr[i].CL.length == 1)
                            temp = this.utilGetErrorLanguage(_errArr[i].CL[0]);
                        else {
                            var arr_ags = this.splitColumnName(_errArr[i].CL);
                            temp = arr_ags.join("\n\n");
                        }
                    }

                    msg += temp + "\n\n";
                }

                return msg;
            },
            manualTriggerDLS(memData) {

                if (memData.I <= 0)
                    return;

                this.$fire({
                    title: this.getLanguage["MTA"]["CADLS"],
                    html: this.getLanguage["AFF"]["ACT"] + " > " + memData.U,
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            I: memData.I,
                            SAGI: memData.SAGI,
                        };

                        this.postDataApi(`/api/sag/smdls`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    that.getMemberList();
                                }
                            });
                    }
                });
            },
            autoFilterAG(data) {
                if (data.SAGI > 0) {
                    var that = this;
                    var searchQuery = "0"
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${data.AGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                console.log('echo', d.dropdownlist)
                                that.ddSubAgentList = d.dropdownlist;
                                that.ddDefaultSubBrand = d.dropdownlist;
                                that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                                that.searchSubAgent = data.SAGI;
                            }
                        });

                    this.searchSubAgent = data.SAGI;
                }
                  
                if (this.ddAgentList == null || this.ddAgentList.length <= 0) {
                    var that = this;
                    this.getDataApi(`/api/dd/ag/1/0`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddAgentList = d.dropdownlist;
                                that.searchAgent = data.AGIT;
                                that.searchSubAgent = data.SAGI;
                                that.getMemberList(1);

                            }
                        });
                } else {
                    this.searchAgent = data.AGIT;
                    this.searchSubAgent = (data.SAGI > 0) ? data.SAGI : null;
                    this.getMemberList(1);
                }
            },
            renderClassName(header, data) {
                if (header == 'CBL') {
                    return "tableCtnRight";
                } else if (header == 'U') {
                    return "kema-eft";
                }
            },
            resetColumn(headerName) {
                var that = this;
                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('MO', 'M', type);
            },
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'M';
            this.$parent.showActiveMenu = 'M.MO';
            this.searchAgent = this.$route.query.agi;
            this.searchCurrency = this.$route.query.ci;
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.MCMI_V = this.checkModuleAccess('MCMI', 'M', constAccessType.view);
            if (this.getUserInfo.AT == 4) {
                if (this.checkModuleAccess('MD', 'D', constAccessType.add)) {
                    this.bool_DepositFunc = true;
                }
                if (this.checkModuleAccess('MW', 'W', constAccessType.add)) {
                    this.bool_WithdrawalFunc = true;
                }
                if (this.getUserInfo.IOL == 1) {
                    if (this.checkModuleAccess('DLSS', 'P', constAccessType.view)) {
                        this.bool_DLSFunc = true;
                    }
                }

                this.loadDefaultSubBrand(0);
            }
            else
                this.getMemberList(1);
        },
        watch: {
            getLanguage() {
                this.getMemberList();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/MemberOnline`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }

                                // hide columns for unauthorized access users
                                if (!that.bool_DepositFunc) {
                                    that.removeDefaultColumn('DA')
                                    that.removeColumn('DA')
                                }
                                if (!that.bool_WithdrawalFunc) {
                                    that.removeDefaultColumn('WA')
                                    that.removeColumn('WA')
                                }
                                if (!that.bool_DLSFunc) {
                                    that.removeDefaultColumn('DLS')
                                    that.removeColumn('DLS')
                                }                                
                                if (!(that.checkModuleAccess2(constAccessType.edit))) {
                                    that.removeDefaultColumn('ACT');
                                    that.removeColumn('ACT');
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/MemberOnline/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
    }

</script>



// WEBPACK FOOTER //
// src/components/SideMenu/Member/MemberOnline.vue